// removed by extract-text-webpack-plugin
module.exports = {"mapFrame":"map-module__mapFrame___2UXXK","mapWrapper":"map-module__mapWrapper___1ahAG","leafletMap":"map-module__leafletMap___1vpz-","region":"map-module__region___1AgaV","navigationControlBtns":"map-module__navigationControlBtns___2rBWn","circleMarker":"map-module__circleMarker___1yfNX","imageMarker":"map-module__imageMarker___25-w7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map/map.module.scss
// module id = 391
// module chunks = 0